// Footer.js
import React from 'react';
import { Box, Container, Typography, Link } from '@mui/material';

const Footer = () => (
  <Box component="footer" sx={{ py: 4, backgroundColor: 'grey.900', color: 'white' }}>
    <Container>
      <Typography variant="body2" align="center">
        &copy; {new Date().getFullYear()} LUCHO | <Link href="#" color="inherit">Términos</Link> | <Link href="#" color="inherit">Política de Privacidad</Link>
      </Typography>
    </Container>
  </Box>
);

export default Footer;
